<template>
<!-- <div class="text-container">
  <div  class="agreement-titile">“爱开”用户服务协议</div>

  <div class="content-titile">一、导言</div>

  <p>欢迎您使用“爱开IDrive”及相关服务！</p>

  <p>“爱开IDrive”（以下简称“爱开”）APP及相关服务，系指杭州邮鸽网络科技有限公司（以下简称“公司”）合法拥有并运营的、标注名称为“爱开IDrive”的客户端应用程序向您提供的产品与服务。《“爱开”用户服务协议》（以下称“本协议”）是您与公司就您下载、安装、注册、登录、使用（以下统称“使用”）“爱开”软件，并获得“爱开”软件提供的相关服务所订立的协议。</p>

  <p>为了更好地为您提供服务，请您在开始使用“爱开”软件及相关服务之前，认真阅读并充分理解本协议，特别是涉及免除或者限制责任的条款、权利许可和信息使用的条款、同意开通和使用特殊单项服务的条款、法律适用和争议解决条款等。其中，免除或者限制责任条款等重要内容将以加粗形式提示您注意，您应重点阅读。</p>

  <p>如您不同意本协议，这将导致公司无法为您提供完整的产品和服务，您也可以选择停止使用。如您自主选择同意或使用“爱开”软件及相关服务，则视为您已充分理解本协议，并同意作为本协议的一方当事人接受本协议以及其他与“爱开”软件及相关服务相关的协议和规则（包括但不限于《“爱开”隐私协议》）的约束。</p>

  <div class="content-titile">二、“爱开”软件及相关服务</div>

  <p>1.&nbsp;您使用“爱开”软件及相关服务，可以通过预装、公司已授权的第三方下载等方式获取“爱开”客户端应用程序或访问爱开相关网站。</p>

  <p>2.&nbsp;公司可能为不同的终端设备开发不同的应用程序软件版本，您应当根据实际设备状况获取、下载、安装合适的版本。</p>

  <p>3.&nbsp;您可根据需要自行使用“爱开”软件及相关服务或更新“爱开”版本，如您不再需要使用“爱开”软件及相关服务，您也可自行卸载相应的应用程序软件。</p>

  <p>4.&nbsp;为更好的提升用户体验及服务，公司将不定期提供“爱开”软件及相关服务的更新或改变（包括但不限于软件修改、升级、功能强化、开发新服务等），您可根据需要自行选择是否更新相应的版本。为保证“爱开”软件及相关服务安全、提升用户服务，“爱开”软件及相关服务部分或全部更新后，公司将在可行情况下以适当方式（包括但不限于系统提示、公告、站内信等）提示您，您有权选择接受更新后版本；如您选择不作更新，则“爱开”软件及相关服务的部分功能将受到限制或不能正常使用。</p>

  <p>5.&nbsp;除非得到公司明示事先书面授权，您不得以任何形式对“爱开”软件及相关服务进行包括但不限于改编、复制、传播、垂直搜索、镜像或交易等未经授权的访问或使用。</p>

  <p>6.&nbsp;鉴于网络服务的特殊性，用户需同意爱开会变更、中断部分或全部的网络服务，并删除（不再保存）用户在使用过程中提交的任何资料，而无需通知用户，也无需对任何用户或任何第三方承担任何责任。</p>

  <p>7.&nbsp;爱开需要定期或不定期地对提供网络服务的平台进行检测或者更新，如因此类情况而造成网络服务在合理时间内的中断，爱开无需为此承担任何责任。</p>

  <div class="content-titile">三、关于“帐号”</div>

  <p>1.&nbsp;账号注册</p>

  <p>1.1&nbsp;用户在使用本服务前需要注册一个“爱开IDrive”账号。账号应当使用手机号码作为用户名注册，请用户使用尚未注册过爱开的手机号码，以及未被爱开根据本协议封禁的手机号码注册。</p>

  <p>1.2&nbsp;如果注册申请者有被爱开封禁的先例或涉嫌虚假注册及滥用他人名义注册，及其他不能得到许可的理由，爱开有权冻结该账号。</p>

  <p>1.3&nbsp;在用户注册、激活及使用本服务时，爱开需要搜集能识别用户身份的个人信息以便可以在必要时联系用户，或为用户提供更好的使用体验。爱开搜集的信息包括但不限于用户的姓名、地址；爱开同意对这些信息的使用将受限于第三条用户个人隐私信息保护的约束。</p>

  <p>1.4&nbsp;您理解并承诺，您所设置的帐号不得违反国家法律法规及“爱开”的相关规则，您的手机号、用户名等注册信息及其他个人信息中不得出现违法和不良信息，未经他人许可不得用他人名义开设帐号，不得恶意注册“爱开”帐号。您在帐号注册及使用过程中需遵守相关法律法规，不得实施任何侵害国家利益、损害其他公民合法权益，有害社会道德风尚的行为。公司有权对您提交的注册信息进行审核。</p>

  <p>2.&nbsp;账户安全</p>

  <p>2.1&nbsp;用户一旦注册成功，成为爱开的用户，将得到一个用户名和密码，并有权利使用自己的用户名及密码随时登陆爱开。</p>

  <p>2.2&nbsp;用户不得以任何形式擅自转让或授权他人使用自己的爱开账户。</p>

  <p>2.3&nbsp;用户对用户名和密码的安全负全部责任，同时对以其用户名进行的所有活动和事件负全责。</p>

  <p>2.4&nbsp;由于用户自身原因发生账号密码泄露，导致的财产损失或其他损失，以及法律责任，由用户个人承担全部责任。如果用户泄漏了账号密码，有可能导致不利的法律后果，因此不管任何原因导致用户的密码安全受到威胁，应该立即和爱开客服人员取得联系，否则由用户担全部责任。</p>

  <p>3.&nbsp;内容发布账号</p>

  <p>用户注册爱开内容发布账号，制作、发布、传播信息内容的，应当使用真实身份信息及个人资料，不得以虚假或冒用的居民身份信息、企业相关信息进行注册。未经相关权利人授权，用户不得以他人或其他组织机构名义注册爱开账号，亦不得使用引人误解的信息注册爱开账号。用户仅第一次发布内容时可提交信息作者昵称，一经审核不可修改，作者昵称审核标准：</p>

  <p>（1）遵守相关法律法规，不得含有违法和不良信息；</p>

  <p>（2）爱开信息平台内昵称不得重复；</p>

  <p>（3）昵称不得包含、隐含敏感人名（领导人、各界知名人士姓名等）。</p>

  <div class="content-titile">四、用户个人信息保护</div>

  <p>公司与您一同致力于您个人信息的保护。</p>

  <p>保护用户个人信息是公司的基本原则之一，在使用“爱开”软件及相关服务的过程中，您可能需要提供您的个人信息（包括但不限于您的姓名、电话号码、身份证信息、驾驶证信息等），以便公司向您提供更好的服务和相应的技术支持。公司将依法保护您浏览、修改、删除相关个人信息以及撤回授权的权利，并将运用加密技术、匿名化处理等其他与“爱开”软件及相关服务相匹配的技术措施及其他安全措施保护您的个人信息。</p>

  <p>更多关于您个人信息保护的内容，请参看《“爱开”隐私协议》。</p>

  <div class="content-titile">五、用户行为规范</div>

  <p>1.&nbsp;用户行为要求</p>

  <p>您应对您使用“爱开”软件及相关服务的行为负责，您使用“爱开”软件及相关服务不得具有下列行为：</p>

  <p>1.1&nbsp;利用或针对“爱开”软件及相关服务进行任何危害计算机网络安全的行为，包括但不限于：</p>

  <p>（1）非法侵入网络、干扰网络正常功能、窃取网络数据等危害网络安全的活动；</p>

  <p>（2）提供专门用于从事侵入网络、干扰网络正常功能及防护措施、窃取网络数据等危害网络安全活动的程序、工具；</p>

  <p>（3）明知他人从事危害网络安全的活动的，为其提供技术支持、支付结算等帮助；</p>

  <p>（4）使用未经许可的数据或进入未经许可的服务器/帐号；</p>

  <p>（5）未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；</p>

  <p>（6）未经许可，企图探查、扫描、测试“爱开”系统或网络的弱点或其它实施破坏网络安全的行为；</p>

  <p>（7）企图干涉、破坏“爱开”系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；</p>

  <p>（9）对“爱开”软件及相关服务进行反向工程、反向汇编、编译或者以其他方式尝试发现“爱开”软件及相关服务的源代码；</p>

  <p>（10）恶意注册“爱开”帐号，包括但不限于频繁、批量注册帐号；</p>

  <p>（11）违反法律法规、本协议、公司的相关规则及侵犯他人合法权益的其他行为。</p>

  <p>1.2&nbsp;如果公司有理由认为您的行为违反或可能违反上述约定的，公司可独立进行判断并处理，且在任何时候有权在不事先通知的情况下终止向您提供服务，并依法追究相关责任。</p>

  <p>2.&nbsp;信息内容展示及规范</p>

  <p>2.1&nbsp;您按规定完成实名认证后，可以以注册帐号或“爱开”合作平台帐号登录“爱开”发布信息、互动交流、评论等。您在“爱开”中因相关操作所形成的关注、粉丝信息将会向其他用户展示。</p>

  <p>2.2&nbsp;公司致力使发布信息、互动交流、评论成为文明、理性、友善、高质量的意见交流。在推动发布信息、互动交流、评论业务发展的同时，不断加强相应的信息安全管理能力，完善发布信息、互动交流、评论自律，切实履行社会责任，遵守国家法律法规，尊重公民合法权益，尊重社会公序良俗。</p>

  <p>2.3&nbsp;用户上传内容将由爱开运营审核，审核通过的文章内容由爱开运营整理编辑后发布至爱开APP并标注原创作者昵称，审核通过的用户发布信息内容的使用权归爱开所有，审核不通过的文章则不被允许展示在爱开APP。</p>

  <p>2.4&nbsp;您制作、评论、上传、传播的信息应自觉遵守法律法规、社会主义制度、国家利益、公民合法权益、社会公共秩序、道德风尚和信息真实性等“七条底线”要求，否则公司有权立即采取相应处理措施。您同意并承诺不制作、复制、发布、传播下列信息：</p>

  <p>（1）反对宪法确定的基本原则的；</p>

  <p>（2）危害国家安全，泄露国家秘密的；</p>

  <p>（3）颠覆国家政权，推翻社会主义制度，煽动分裂国家，破坏国家统一的；</p>

  <p>（4）损害国家荣誉和利益的；</p>

  <p>（5）宣扬恐怖主义、极端主义的；</p>

  <p>（6）宣扬民族仇恨、民族歧视，破坏民族团结的；</p>

  <p>（7）煽动地域歧视、地域仇恨的；</p>

  <p>（8）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>

  <p>（9）编造、散布谣言、虚假信息，扰乱经济秩序和社会秩序、破坏社会稳定的；</p>

  <p>（10）散布、传播淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>

  <p>（11）危害网络安全、利用网络从事危害国家安全、荣誉和利益的；</p>

  <p>（12）侮辱或者诽谤他人，侵害他人合法权益的；</p>

  <p>（13）对他人进行暴力恐吓、威胁，实施人肉搜索的；</p>

  <p>（14）涉及他人隐私、个人信息或资料的；</p>

  <p>（15）散布污言秽语，损害社会公序良俗的；</p>

  <p>（16）侵犯他人隐私权、名誉权、肖像权、知识产权等合法权益内容的；</p>

  <p>（17）散布商业广告，或类似的商业招揽信息、过度营销信息及垃圾信息；</p>

  <p>（18）使用本网站常用语言文字以外的其他语言文字评论的；</p>

  <p>（19）与所评论的信息毫无关系的；</p>

  <p>（20）所发表的信息毫无意义的，或刻意使用字符组合以逃避技术审核的；</p>

  <p>（21）侵害未成年人合法权益或者损害未成年人身心健康的；</p>

  <p>（22）未获他人允许，偷拍、偷录他人，侵害他人合法权利的；</p>

  <p>（23）包含恐怖、暴力血腥、高危险性、危害表演者自身或他人身心健康内容的，包括但不限于以下情形：</p>

  <p>i.&nbsp;任何暴力和/或自残行为内容；</p>

  <p>ii.&nbsp;任何威胁生命健康、利用刀具等危险器械表演的危及自身或他人人身及/或财产权利的内容；</p>

  <p>iii.怂恿、诱导他人参与可能会造成人身伤害或导致死亡的危险或违法活动的内容；</p>

  <p>（24）以任何方式损害爱开运营方及其关联公司的商誉或信誉等合法权益；</p>

  <p>（25）&nbsp;从事其他任何影响爱开运营方正常运营、破坏爱开经营模式或其他有害爱开生态的行为；</p>

  <p>（26）为其他任何非法目的而使用爱开服务。</p>

  <div class="content-titile">六、“爱开”信息内容使用规范</div>

  <p>1.&nbsp;未经公司书面许可，任何用户均不得自行或授权、允许、协助他人对“爱开”软件及相关服务中信息内容进行如下行为：</p>

  <p>（1）复制、读取、采用“爱开”软件及相关服务的信息内容，用于包括但不限于宣传、增加阅读量、浏览量等商业用途；</p>

  <p>（2）擅自编辑、整理、编排“爱开”软件及相关服务的信息内容后在“爱开”软件及相关服务以外的渠道进行展示；</p>

  <p>（3）采用包括但不限于特殊标识、特殊代码等任何形式的识别方法，自行或协助第三人对“爱开”软件及相关服务的信息内容产生流量、阅读量引导、转移、劫持等不利影响；</p>

  <p>（4）其他非法获取或使用“爱开”软件及相关服务的信息内容的行为。</p>

  <p>2.&nbsp;未经公司书面许可，任何用户、第三方不得以任何方式直接或间接盗取“爱开”软件及相关服务的视频、图文等信息内容，或以任何方式删除或改变相关信息内容的权利管理电子信息。</p>

  <div class="content-titile">七、服务的终止</div>

  <p>1.&nbsp;在下列情况下，爱开有权终止向用户提供服务：</p>

  <p>（1）用户违反本服务协议相关规定时，爱开有权终止向该用户提供服务。如该用户再一次直接或间接或以他人名义注册为用户的，一经发现，爱开有权直接单方面终止向该用户提供服务；</p>

  <p>（2）如爱开通过用户提供的信息与用户联系时，发现用户在注册时填写的联系方式已不存在或无法接通，爱开以其它联系方式通知用户更改，而用户在三个工作日内仍未能提供新的联系方式时，爱开有权终止向该用户提供服务；</p>

  <p>（3）用户不得通过程序或人工方式进行刷量或作弊，若发现用户有作弊行为，爱开将立即终止服务，并有权扣留用户账户中的资金；</p>

  <p>（4）一旦爱开发现用户提供的数据或信息中含有虚假内容，爱开有权随时终止向该用户提供服务；</p>

  <p>（5）本服务条款终止或更新时，用户明示不愿接受新的服务条款；</p>

  <p>（6）其它爱开认为需终止服务的情况。</p>

  <p>2.&nbsp;服务终止后，爱开没有义务为用户保留原账号中或与之相关的任何信息，或转发任何未曾阅读或发送的信息给用户或第三方。</p>

  <div class="content-titile">八、免责与赔偿声明</div>

  <p>1.&nbsp;若爱开已经明示其服务提供方式发生変更并提醒用户应当注意事项，用户未按要求操作所产生的一切后果由用户自行承担。</p>

  <p>2.&nbsp;用户明确同意其使用爱开所存在的风险将完全由其自己承担，因其使用爱开而产生的一切后果也由其自己承担。</p>

  <p>3.&nbsp;用户同意保障和维护爱开及其他用户的利益，由于用户在使用爱开有违法、不真实、不正当、侵犯第三方合法权益的行为，或用户违反本协议项下的任何条款而给爱开及任何其他第三方造成损失，用户同意承担由此造成的损害賠偿责任。</p>

  <div class="content-titile">九、知识产权</div>

  <p>1.&nbsp;公司在“爱开”软件及相关服务中提供的内容（包括但不限于软件、技术、程序、网页、文字、图片、图像、音频、视频、图表、版面设计、电子文档等）的知识产权属于公司所有。公司提供“爱开”及相关服务时所依托的软件的著作权、专利权及其他知识产权均归公司所有。未经公司许可，任何人不得擅自使用“爱开”软件及相关服务中的内容。</p>

  <p>2.&nbsp;您理解并承诺，您在使用“爱开”软件及相关服务时上传的内容（包括但不限于文字、图片、视频、音频等各种形式的内容及其中包含的音乐、声音、台词、视觉设计等所有组成部分）均由您原创或已获合法授权（且含转授权）。您通过“爱开”上传所产生内容的知识产权归属您或原始著作权人所有。</p>

  <p>3.&nbsp;公司为“爱开”开发、运营提供技术支持，并对“爱开”软件及相关服务的开发和运营等过程中产生的所有数据和信息等享有法律法规允许范围内的全部权利。</p>

  <div class="content-titile">十、其他</div>

  <p>1.&nbsp;本协议的成立、生效、履行、解释及争议的解决均应适用中华人民共和国法律。倘若本协议之任何规定因与中华人民共和国法律抵触而无效，则这些条款应在不违反法律的前提下按照尽可能接近本协议原条文目的之原则进行重新解释和适用，且本协议其它规定仍应具有完整的效力及效果。</p>

  <p>2.&nbsp;为给您提供更好的服务或因国家法律法规、政策调整、技术条件、产品功能等变化需要，公司会适时对本协议进行修订，修订内容构成本协议的组成部分。本协议更新后，公司会在“爱开”发出更新版本，并在更新后的条款生效前通过适当的方式提醒您更新的内容，以便您及时了解本协议的最新版本，您也可以在软件设置页面查阅最新版本的协议条款。如您继续使用“爱开”软件及相关服务，即表示您已同意接受修订后的本协议内容。</p>

  <p>如您对修订后的协议内容存有异议的，请立即停止登录或使用“爱开”软件及相关服务。若您继续登录或使用“爱开”软件及相关服务，即视为您认可并接受修订后的协议内容。</p>

  <p>3.&nbsp;本协议中的标题仅为方便阅读而设，并不影响本协议中任何规定的含义或解释。</p>

  <p></p>
</div> -->

<div class="text-container">
  <div class="agreement-titile">“爱开”用户服务协议</div>
  <p>本协议是您与服务、产品及网站本身等的所有者邮鸽软件有限公司，就相关服务等事宜订立的契约。请您认真阅读并充分理解本服务协议，本协议构成对双方有约束力的法律文件。&nbsp;</p>

  <p class="content-titile">一、协议目的</p>
  <p>本协议中的“您”与“用户”指任何使用和/或访问本服务的个人。本协议及邮鸽针对本服务发布的其它服务条款、规则或提示（以下合称为“本协议”）是我们为您提供本服务以供使用及访问所依据的条款。通过本协议，您将了解邮鸽向您提供本服务的方式、本服务所允许及禁止的活动、应对问题的措施及其他重要信息。请您仔细阅读本协议，特别是涉及免除或者限制责任的条款、法律适用和争议解决条款等以加粗形式提示的重要内容。</p>

  <p> 当您按照页面提示同意本协议或使用本服务，即视为您已与邮鸽达成具有法律约束力的合同，邮鸽将按照本协议约定履行相应的合同义务。若您不同意本协议，请勿使用本服务。</p>

  <p> 若您对本协议存在任何疑问，您可通过“联系我们”章节中的联络信息联系我们。&nbsp;</p>

  <p>1.您明确声明和保证并确认以下内容：<br></p>
  <div class="content-text3">
    <p>1）您具备足够的法律权利或授权来签署和履行本协议；您对于本协议的签署和履行不会对您须履行的任何其他协议、安排造成冲突或导致违约。</p>
    <p>2）并且您需要确认，若您使用本网站，您应当具备完全民事权利能力和完全民事行为能力，能够独立承担法律责任。用户违反本项条件，邮鸽可随时、全权决定拒绝向您提供服务，若因此给邮鸽或第三方造成损失，用户还须承担全部赔偿责任。如您为无民事行为能力人或为限制民事行为能力人，例如您未满18周岁，在您决定是否使用本服务前，请您与父母或其他监护人一起阅读本协议以确保他们明确了解本协议内容，在获得父母或其他监护人同意之前，请勿使用本服务，在父母或监护人的监护参与下才能使用本网站，否则邮鸽有权在法律允许范围内冻结、关闭或删除您的帐户。</p>
    <p>3）您同意，授权邮鸽存储、使用、共享您提交至邮鸽数字平台的个人信息和其它信息，同意您的个人信息可以在邮鸽公司关联企业之间共享，也可以在为您提供服务的第三方物流公司、第三方商家店铺、邮鸽合作方或服务商之间使用。在此情况下，第三方服务提供商也会拥有您的部分或全部用户数据。您了解并确认，邮鸽第三方商家店铺、物流提供商、第三方合作方或服务提供商通常有其自身的隐私政策，且可能与邮鸽的隐私政策不同，邮鸽无需承担第三方对您隐私的保护责任。</p>
    <p>4）您同意，在享用邮鸽各项服务的同时，您及您指定的收货人同意接收邮鸽或邮鸽第三方商家店铺提供的各类信息服务，这些信息所涉及的内容包括但不限于以文字、图片、照片、音视频形式表现的各类订单信息、宣传信息、促销信息、商业信息以及邮鸽合作伙伴的信息，该类信息的提供方式包括但不限于电子邮件、短信、电话、站内信、微信消息等。&nbsp;</p>
  </div>

  <p class="content-titile">二、服务内容及范围<br></p>
  <p> 1、帐号功能【邮鸽账户中心】</p>

  <p>“邮鸽帐号”作为邮鸽业务的通行凭证，邮鸽服务的很多内容需要您具有邮鸽帐户才能访问和使用。用户有权使用其合法获得的邮鸽账户权益，如您违反本协议及权益的相关规定，邮鸽有权决定收回相关账户权益且无需征得您的同意。&nbsp;</p>

  <div class="content-text3">
    <p> 1）创建帐户及账户使用。<br>
      您可以通过在线注册创建邮鸽帐户，一旦成功注册，您将得到一个用户名和密码，为保护您的帐户，请对您的帐户详细信息和密码、实名认证、手机绑定等网站服务时网站发送的校验码进行保密，因泄密造成的后果，由用户自行承担。您应对您的邮鸽帐户下发生的所有活动及行为负责。注册邮鸽帐户时，应自行向邮鸽提供真实、准确、完整、合法有效的用户信息，并且当您的个人信息发生变动时，应及时进行更新。如果您提供的个人信息不合法、不真实、不准确、不详尽，您须承担因此引起的相应责任及后果，并且邮鸽保留法律允许范围内独自决定关闭、删除用户帐户的权利。如果您代表一个实体（如您的企业或雇主）创建邮鸽帐户，则您声明您具有约束该实体遵守这些条款的法定权利。您不得将邮鸽帐户凭据转让给其他用户或实体。</p>

    <p>且如果邮鸽有合理理由认为您的邮鸽帐户有遭到第三方欺诈性冒用（例如，帐户被入侵所致）的风险，则邮鸽可能会暂停您的帐户，直到您可以重新取回所有权。根据入侵的性质，我们可能需要禁止您访问部分或所有内容。</p>
  </div>

  <p> 2）关闭您的帐户或中（终）止邮鸽账户项下的服务。<br></p>
  <div class="content-text3">
    <p> （a）您可以出于任何原因随时取消特定的服务或关闭您的邮鸽帐户。当您要求我们关闭您的邮鸽帐户时，<br>
      （b）如果您的邮鸽帐户已被关闭或服务已被取消（无论被您关闭还是被我们关闭），将会出现以下情形。首先，您使用邮鸽帐户及访问服务的权利将立即终止，您的与服务相关的软件的许可也将终止。其次，我们将会删除与您的邮鸽帐户关联的数据或您的内容，或者切断数据或您的内容与您和&nbsp;邮鸽帐户间的关联关系（但法律要求我们进行保留，或者将其返还或转让给您或您指定的第三方的除外）。这样一来，您可能无法再访问任何服务（或您在这些服务上存储的内容）。您应制定定期备份计划，因为邮鸽无法对已关闭帐户进行关于您的内容或数据的检索。第三，您可能无法再访问您已购买的产品。如果您已取消了您的邮鸽帐户，并且没有其他可访问服务的帐户，则您的服务可能会被立即取消。</p>

  </div>
  <p class="content-titile">三、购买与交易订单<br></p>
  <p>商品信息价格<br></p>
  <p>1.&nbsp;本网站的产品和服务信息随时都有可能发生变动，当前产品及服务的实时价格请参见相关产品及服务的定价界面或与我们取得联系。</p>

  <p> 您同意，付费服务的提供商有权调整购买价格，并在购买行为发生前的合理时间内通知您价格调整详情。新价格生效后，您需要接受新调整的价格才能继续购买相关商品或服务，您在价格调整前购买的产品和服务不受影响。若您不接受调整后的价格，可停止使用相关商品或服务。</p>

  <div class="content-text3">
    <p>&nbsp;&nbsp; 1）下单：您可以在本平台完成对于下述服务和产品的下单订购：<br></p>
    <p>&nbsp;&nbsp;邮鸽产品整合的解决方案 等其他产品及服务</p>
    <p>&nbsp;&nbsp;2）付款方式。如果您购买了服务，则这些付款方式适用于您的购买，并且您同意这些付款方式。您需要为您需要或已经生成订单的的产品、服务支付对应的费用。如果我们未准时收到您的所有款项，那么我们可能会暂停或取消服务。若要支付某项服务的费用，您需要在注册该项服务时提供一种付款方式。目前我们支持支付宝、微信、对公转账等的支付方式。</p>
    <p>&nbsp;&nbsp;3）发票。&nbsp;您可以在邮鸽账户后台查看交易的订单，您可以根据每笔订单或多笔订单申请开票。您需要向我们准确地提供您的开票信息。</p>
    <p>&nbsp;&nbsp;4）退款。详细流程和退款方式根据产品和服务的类型不同而不同，具体可咨询对应产品的客服人员。</p>
    <p>&nbsp;&nbsp;5）帐号与交易安全。您应当通过真实身份信息认证注册邮鸽帐号，并承诺妥善保管您的帐号信息、帐号密码、交易密码、银行卡或信用卡信息和此帐号相关信息（包括但不限于此帐号登录过的设备信息、订单信息、操作记录等）（下称“帐户及交易信息”），不得与任何人分享此类信息。我们建议您选择安全等级高的密码并采取恰当的措施来保护您的帐号信息和密码。若您将上述信息提供给第三方或丢失手机等设备，由此产生的损失与责任由您自行承担。</p>

  </div>
  <p> 若您认为有人可能在使用您的帐户及交易信息，则您应通过“联系我们”章节中的联络信息立即告知我们。您还应立即更改相关密码。您不得使用其他人的邮鸽帐号来访问本服务。您应采取恰当的措施来保护您的帐户及交易信息，避免第三方未经授权使用您的前述信息。</p>

  <p> 如您因个人原因导致邮鸽帐号信息遗失，需要找回邮鸽帐号信息，可按照邮鸽帐号申诉流程提供相应的信息进行找回，能否申诉成功依赖于您提供的信息是否有效完备。</p>

  <p class="content-titile">四、用户履约准则<br></p>
  <p>1.&nbsp;用户使用邮鸽账户必须遵守国家法律法规，用户承诺，绝对不会通过邮鸽的任何服务发送或传播违反国家法律法规及不文明的信息，此类信息包括但不限于：
  </p>
  <div class="content-text3">
    <p>（1）反对宪法所确定的基本原则的；</p>
    <p>（2）危害国家安全、泄露国家秘密、颠覆国家政权、破坏国家统一、损害国家荣誉和利益的；</p>
    <p>（3）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
    <p>（4）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
    <p> （5）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
    <p>（6）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的</p>
    <p> （7）恐吓、侮辱、攻击、诽谤他人，侵害他人合法权益的；</p>
    <p> （8）利用本网站从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动的；</p>
    <p> （9）发布任何侵犯他人著作权、商标权等知识产权及其他合法权利的；</p>
    <p>（10）含有法律、行政法规禁止的其他内容的。</p>
  </div>

  <p> 2.&nbsp;除本协议明确约定或适用法律允许以外，否则您同意且承诺不会进行以下任何活动：</p>
  <div class="content-text3">
    <p>（1）&nbsp;删除本服务内包含的任何版权、商标或其它专有通知；</p>
    <p>（2）&nbsp;复制或更改本服务的全部或部分内容，或允许本服务或其中任何部分与其他任何程序合并或合入其他任何程序；</p>
    <p>（3）&nbsp;未经授权访问或尝试访问或损害本服务或相关系统或网络的任何部分；</p>
    <p>（4）&nbsp;分解、解码或逆向开发本服务或其任一部分，或基于本服务或其任一部分创造衍生作品，或企图从事适用法律所禁止的类似活动；</p>
    <p>（5）&nbsp;分发、许可、租赁、出售、转售、转让、公开展示、公开表演、传输、播放、传播或以其他方式使用本服务；</p>
    <p>（6）&nbsp;未经邮鸽事先书面许可，以任何形式将本服务全部或部分内容（包括标的物及源代码）提交或以其他方式提供给任何人；</p>
    <p>（7）&nbsp;冒充他人、伪称或以其他方式虚报您与某人或某实体的关系；</p>
    <p>（8）&nbsp;出于非法目的，以任何不法形式，或违反本协议的方式使用本服务（或其任何部分），或实施任何欺诈或其他恶意行为，包括但不限于入侵本服务（或本服务链接的网址）或任何操作系统或向其植入恶意代码，包括病毒或有害数据；</p>
    <p>（9）&nbsp;访问和/或使用本服务时侵犯邮鸽或任何第三方的知识产权；</p>
    <p>（10）&nbsp;搜集本服务用户的信息，或使用自动化手段来访问本服务或邮鸽系统，或试图通过破译向运行本服务的服务器中传入任何内容或从中提取任何内容；</p>
    <p>（11）&nbsp;开发、支持或使用软件、设备、脚本或任何其他手段或进程（包括爬虫软件、浏览器插件或任何其他技术或人为作业）来攫取本服务或以其他方式从本服务中拷贝用户信息及其他数据；</p>
    <p> （12）&nbsp;未经邮鸽事先书面许可将本服务用于商业用途；</p>
    <p> （13）&nbsp;使用本服务从事任何违法商业交易，比如贩卖军火、毒品、非法物品、盗版软件或其他违禁品；</p>
    <p>（14）&nbsp;提供赌博信息或使用任何手段引诱他人赌博；</p>
    <p>（15）&nbsp;索要他人登录信息或访问他人帐号；</p>
    <p>（16）&nbsp;参与洗钱、套现或传销活动；</p>
    <p>（17）&nbsp;使用本服务时损害、禁用、削弱或危及本服务、邮鸽系统或其安全，或使其超负荷，干扰其他用户或任何其他方的电脑系统，入侵或未经授权访问本服务或邮鸽内容或数据；</p>
    <p>（18）&nbsp;试图违反本协议（或其中任何部分），或助推或怂恿此类行为。</p>
  </div>

  <p> 3.用户违反上述规定的，邮鸽有权视情节的严重采取警告、限期改正、暂停服务、取消订单、禁止交易、关闭帐号、永久禁止注册等措施，给邮鸽或第三方造成损失的，邮鸽有权采取一切合法的诉讼与非诉讼手段进行索赔；用户行为构成犯罪的，邮鸽有权通知和协助政府部门进行查处。</p>

  <p> 4.当您为产品及服务下订单时，请您仔细确认所购产品包括费用、服务时长、并发账号数量、收货人姓名、电话、详细地址等信息。收货人与您本人不一致的，收货人的行为和意思表示视为您的行为和意思表示，您应对收货人的行为及意思表示的法律后果承担连带责任。&nbsp;</p>

  <p class="content-titile">五、知识产权</p>
  <p> 1.邮鸽的内容<br></p>
  <p>除本协议明确约定或适用法律另有规定以外，邮鸽和/或邮鸽的许可方对根据本服务或经由本服务获得的所有信息，包括但不限于文本、视频和音频、图片、图标、应用、设计、软件、脚本、程序、版权、商标、商号、标志及其他资料与服务，以及包括前述内容的外观与体验（以下合称为“邮鸽内容”）保留所有权利。除非本协议另行规定，否则您对本服务的访问和/或使用并不构成本服务或其中内容的任何所有权或其他权利向您或其他任何人的转移。您不得通过任何方式更改、复制、提取、修订或增添邮鸽内容，也不得出售、拷贝、传播、许可或滥用邮鸽内容。</p>

  <p> 若您认为本服务或其任何部分侵犯了任何版权、商标、专利、商业机密或其他知识产权，或您对本服务存在其他疑问，请通过“联系我们”章节中的联络信息告知我们。</p>

  <p> 2.您的内容&nbsp;<br><br>
    我们的许多服务允许您存储或共享您的内容，或者接收他人发送的材料。我们不会对您的内容主张所有权。对于您上传、发布及以其他方式传输至本服务或通过本服务传输的文本、文件、图片、照片或其他信息（以下合称为“您的内容”），您继续保留对您的内容的所有权；您对您的内容全权负责。<br>
    在与他人共享您的内容时，您了解他们可在全球范围内，出于与您在服务上提供内容一致的目的使用、保存、记录、复制、广播、传输、分享和显示您的内容，而不会为您提供任何补偿。如果您不希望他人拥有上述权利，请不要使用服务来共享您的内容。您声明并保证，在这些条款的有效期内，您拥有（并将一直拥有）您上传、存储到服务或通过服务共享的您的内容的所有必要权利，并且我们收集、使用和保留您的内容不会违反任何法律和他人的权利。邮鸽并不拥有、控制、验证、支付、认可您的内容，或者以其他方式对您的内容承担任何责任，并且，邮鸽不会对他人使用我们的服务上传、存储或共享的您的内容或材料承担任何责任。</p>

  <p> 3.软件许可<br><br>
    任何被我们当作服务一部分为您提供的软件均受这些条款的约束，但附有单独的邮鸽许可协议的除外，根据你选取的产品及服务的类型，你提供购买产品及服务获得的许可权利。</p>

  <p class="content-titile">六、数据及隐私保护<br></p>
  <p>我们非常重视您的个人信息和隐私保护。您理解并同意，在您使用本服务的过程中，出于提供本服务所必需的目的或者基于您的同意，我们将根据《邮鸽隐私政策》（http://www.yoogate.cn/privacyAgreement）（以下简称为“《隐私政策》”）处理您的个人信息。为此，您需要仔细阅读单独明示的《隐私政策》，以了解我们处理个人信息的目的、方式，处理的个人信息种类、保存期限，用户权利行使方式和程序以及邮鸽为保护您的个人信息所采取的措施以及我们会通过何种方式使用您的数据以及我们处理您的数据时所依照的法律依据等信息。为了更好地向您提供本服务，保证您的交易安全，邮鸽会根据收集并处理您的个人信息。若处理活动已征得同意，则在法律允许的范围内，使用服务或同意这些条款，即表示您同意我们按照邮鸽各产品相关的隐私政策中的规定收集、使用和披露您的内容和数据。在某些情况下，我们会提供单独的通知，要求您按隐私政策所述给予同意。</p>

  <p> 1.&nbsp;邮鸽非常重视保护用户个人信息，凡涉及用户姓名、电话、详细地址、电子邮箱、帐号等个人信息的，邮鸽都将予以严格保密，但下列情况除外：<br><br>
    （1）事先获得用户的明确授权；<br>
    （2）法律法规或政府部门要求披露时；<br>
    （3）为维护社会公众利益必须披露时；<br>
    （4）为使邮鸽工作人员、物流服务商、第三方商家、供应商或商业伙伴能向邮鸽提供服务或代表邮鸽执行某一职能（包括但不限于物流配送、市场营销、市场研究、客户服务、抽奖活动，供应邮鸽目前或未来向用户提供的产品或服务）而必须披露时；<br>
    （5）为维护邮鸽的合法利益而必须披露时。</p>

  <p> 2.&nbsp;您须知晓，尽管邮鸽已依照相关法律法规、强制性技术标准及规范，采取适当的并与网络服务相适应的措施，规划、设计和建立了用户数据系统处理流程，订立了用户数据管理制度，并落实有关数据管理责任。但邮鸽仍无法保证完全避免因黑客攻击、计算机病毒侵入或发作、第三方原因或其他原因造成的用户数据泄露、丢失、篡改、不当使用等数据安全/隐私侵犯事件。除非有关法律另行强制规定，您理解并同意，若不属邮鸽故意或明显过错造成的前述事件，不追究邮鸽因此类事件所造成的任何损害赔偿责任或违约责任。&nbsp;</p>

  <p class="content-titile">七、免责及协议终止</p>

  <p> 1.责任限制<br>
    您理解，在符合适用的法律法规的前提下，出于运营及改善本服务的目的（包括但不限于欺诈防范、风险评估、调查及客户支持），我们有权采取必要措施确保您遵守本协议及适用的法律，或法院、政令、行政机关或其他政府机关的命令或要求。</p>

  <p> 我们有权随时审视您的内容是否合适或是否符合本协议。若我们发现您提交的内容有违法或不良信息、违反了本协议或不符合公序良俗时，我们有权在不事先通知的情况下随时酌情拒绝和/或移除您的内容，并有权不予注册帐号。</p>
  <p> 如果邮鸽有合理理由认为您当前使用的邮鸽帐号属于以下情形之一的，邮鸽有权随时限制、冻结或终止您对邮鸽帐号的使用，且根据实际情况决定是否恢复您对邮鸽帐号的使用：</p>
  <div class="content-text3">
    1）非通过邮鸽提供或明确许可的软件或服务获得的邮鸽帐号；<br>
    2）通过欺诈方式获取的邮鸽帐号；<br>
    3）通过恶意注册获取的邮鸽帐号；<br>
    4）使用非您本人真实意思表示注册的邮鸽帐号；<br>
    5）以赠与、借用、租用、转让、售卖或者以其他方式许可他人使用您本人的邮鸽帐号；<br>
    6）为实现非法目的而注册、获取的邮鸽帐号；
  </div>

  <p> 如果您通过上述方式获取和使用邮鸽帐号，您应自行承担相关法律责任和损失（包括但不限于通信中断，虚拟财产及相关数据、增值服务、产品或服务等的清空或无法使用等），同时邮鸽保留追究您法律责任的权利。</p>

  <p> 2.免责声明<br>
    本服务仅供您个人使用，不得提供给任何第三方使用。您同意，对未经授权使用本服务导致的任何损失，邮鸽及邮鸽关联公司、负责人、董事、员工、承包商、代理、第三方支付服务提供商、合作伙伴、许可方及经销商（以下合称为“邮鸽方”）不承担任何责任。</p>

  <p> 用户明确同意信息服务的使用由用户个人承担风险。除非另有明确的书面说明,邮鸽不对本网站上的信息、内容、产品（包括软件）或服务作任何形式的、明示或默示的声明或担保（法律另有规定的以外）。邮鸽不担保服务一定能满足用户的要求，也不担保服务不会受中断，对服务的及时性、安全性、出错都不作任何担保。本服务在使用过程中可能会因不可控制的原因在未知时段内中断、延迟或受到干扰。您同意，对前述中断、延迟、干扰或类似故障导致的或与之相关的任何申索，邮鸽方不承担任何责任。</p>

  <p> 在适用法律允许的最大范围内，对于您或其他任何人因下列原因无法访问或使用本服务导致的任何损害，邮鸽方不承担任何责任：</p>
  <div class="content-text3">

    （1）&nbsp;邮鸽对系统或软（硬）件进行维护或升级导致本服务中止或终止；<br>
    （2）&nbsp;非邮鸽拥有或控制的系统或网络通讯延迟或出现故障；<br>
    （3）&nbsp;因台风、地震、停电、洪水、战争、恐怖袭击等不可抗力因素导致的服务中断；<br>
    （4）&nbsp;由于虚拟数字商品和增值服务提供商或者运营方停止运营而导致的服务停止；<br>
    （5）&nbsp;由于第三方支付渠道故障导到本服务不能正常运行；<br>
    （6）&nbsp;由于黑客攻击或类似的安全影响导致错误或中断；<br>
    （7）&nbsp;超越邮鸽合理控制的其他原因。
  </div>

  <p> 本服务按照“现状”和“现有”提供，且不做任何形式的承诺、保证或担保。在适用的法律允许的最大范围内，邮鸽方未就以下方面承认任何明示或默示的保证、条件或其他协定，也未就此作出任何担保、承诺、声明或保证：</p>
  <div class="content-text3">

    （1）&nbsp;根据本服务或经由本服务获得的任何内容的完整性、准确性、可靠性或及时性；<br>
    （2）&nbsp;本服务或承载本服务的服务器是否存在缺陷、错误、病毒、漏洞或其他有害元素；<br>
    （3）&nbsp;本服务运营或功能方面的缺陷是否会得到修正；<br>
    （4）&nbsp;与本服务特定功能相关的保证，或您在使用或访问本服务时获得的任何信息是否可靠、优质或准确；<br>
    （5）&nbsp;本服务是否安全无误；<br>
    （6）&nbsp;本服务是否可靠、优质、准确、可用或能够满足您的需求、能够产生特定的结果或实现特定的结果或成果。因全部或部分依赖、使用或诠释本服务，或因您（或其他任何人）访问和/或使用通过本服务获得的信息而造成的任何损失或损害，邮鸽方不承担任何责任。
  </div>

  <p>部分国家的法律不允许合同中排除或限制某些保证、担保或责任。若这些法律适用于您，则前述排除或限制条款的全部或部分可能不适用。本协议中的任何内容均不影响您作为消费者应该享有的法定权利。</p>

  <p> 3.协议中（终）止<br></p>
  <p>3.1由您中（终）止<br></p>
  <p> 您可通过注销邮鸽帐号来终止本协议。您也向邮鸽申请账户注销来选择停止使用相应的服务。</p>

  <p> 如您选择注销您的帐号，需要先成功登录帐号，同时请您仔细阅读以下事项：</p>
  <div class="content-text3">
    （1）&nbsp;帐号注销后，您将自愿放弃您账户下的会员权益，并无法恢复。<br>
    （2）&nbsp;帐号注销后，邮鸽不会保留您帐号下的任何资料、文件和存储的内容。同时，您发送给其他用户的内容和消息，也可能无法恢复。<br>
    （3）&nbsp;帐号注销后，您并不会被免除支付在终止日期之前（含）仍应当支付的任何费用的义务，且邮鸽和任何第三方对于您帐号注销后造成的后果不承担任何责任。
  </div>
  <p> 3.2由邮鸽中（终）止<br></p>
  <p> 我们可能依照适用法律和本协议中止、限制、取消或终止您访问全部或部分本服务，而不对任何个人或第三方承担任何责任。我们会在采取前述行动前尽力通知您。但若出现如下情形，我们可能在不事先通知您的情况下立即中止、限制、取消或终止您访问全部或部分本服务：</p>
  <div class="content-text3">
    （1）&nbsp;您违反本协议或邮鸽有理由认为您即将违反本协议，包括其中包含的任何约定、政策或指南；<br>
    （2）&nbsp;您或代表您行事的任何人进行欺诈或违法活动，或向邮鸽提供虚假或误导信息；<br>
    （3）&nbsp;依照有效法律程序响应执法部门或政府机关提出的要求；<br>
    （4）&nbsp;执行紧急的系统或硬件维护更新工作；<br>
    （5）&nbsp;因无法预料的技术、安全或业务原因。
  </div>

  <p> 邮鸽在“按现状”和“按现有”的基础上为用户提供合法的、健康的产品及服务，但是用户应对其使用邮鸽服务自行承担责任及风险，邮鸽在任何情况下不对因使用或不能使用邮鸽提供的服务所发生的特殊的、意外的、直接或间接的损失承担赔偿责任。</p>

  <p> 本站的全部责任，不论是合同、保证、侵权（包括过失）的还是其他责任，均不会超过您的订单金额。&nbsp;</p>

  <p class="content-titile">八、本协议条款修订及更新<br></p>
  <p> 根据国家法律法规变化及网站运营需要，以及邮鸽一直在更新、修订和改善本服务及协议。邮鸽可能为本服务增删功能或性能，设置新的限制或临时中止或永久停止提供某项服务。因此邮鸽有权对本协议条款不时地进行修改，修改后的协议一旦被张贴在网站，新协议立即生效并代替原来的协议。用户有义务不时关注并阅读最新版的协议及网站公告。更新后的协议条款一旦公布即代替原来的协议条款，如果您不接受修改后的条款，请立即停止使用本服务，如您继续使用邮鸽服务，即视为完全同意更新后的协议。并且，如果您是家长或监护人，请帮助您的未成年子女关闭他或她的邮鸽帐户。如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。&nbsp;</p>

  <p class="content-titile">九、联系我们<br></p>
  <p> 如您对本协议有任何疑问，访问http://www.yoogate.cn与我们联系。</p>
</div>
</template>

<script>
export default {
  name: 'serviceAgreement',
  components: {},
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>

<style scoped>
.agreement-titile {
  font-size: 20px;
  line-height: 40px;
  padding: 15px 40px;
  font-weight: bold;
}

.text-container>p {
  font-size: 16px;
  line-height: 20px;
  padding: 5px 40px;
}

.content-titile {
  font-size: 20px;
  line-height: 30px;
  padding: 15px 40px;
  font-weight: bold;
  text-indent: 0em !important;
}

.content-text3 {
  padding: 15px 40px 15px 50px;
}
</style>
